// extracted by mini-css-extract-plugin
export default {"root":"SurveyDetailsPage_root__cEwlm","restricted":"SurveyDetailsPage_restricted__HjvfT"};